<template>
  <div class="default-modal">
    <el-dialog
      v-model="insurancePopup"
      top="5vh"
      width="70%"
      :close-on-click-modal="false"
    >
      <div class="export-dialog-header">
        <div class="export-header-part">
          <h3>Insurance Details</h3>
        </div>
        <el-button
          size="medium"
          class="el-white"
          type="info"
          plain
          @click="handleInsuranceClose"
        >
          <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon"
        /></el-button>
      </div>
      <div
        id="insurance-details"
        v-if="
          insuranceEligibilityDetails && hasData(insuranceEligibilityDetails)
        "
      >
        <div class="insurance-details-block">
          <ul>
            <template
              v-for="(value, key) in insuranceEligibilityDetails"
              :key="key"
            >
              <li class="insurance-details-list">
                <div class="insurance-block">
                  <p class="insurance-label">{{ key }}:</p>
                  <span v-if="isObject(value) && key !== 'foundCoverages'">
                    <ul class="insurance-sub-order">
                      <li
                        class="insurance-sub-list"
                        v-for="(subValue, subKey) in value"
                        :key="subKey"
                      >
                        <template
                          v-if="
                            subKey !== 'rawResponse' &&
                            subKey !== 'additionalIdentifications' &&
                            subKey !== 'patient' &&
                            subKey !== 'rejectionCodes'
                          "
                        >
                          <div
                            v-if="isObject(subValue)"
                            class="insurance-sub-details"
                          >
                            <strong>{{ subKey }}:</strong>
                            <ul>
                              <li
                                v-for="(nestedValue, nestedKey) in subValue"
                                :key="nestedKey"
                              >
                                <strong>{{ nestedKey }}:</strong>
                                <span v-if="isDate(nestedValue)">
                                  {{ formatDateBilling(nestedValue) }}
                                </span>
                                <span v-else>{{ nestedValue }}</span>
                              </li>
                            </ul>
                          </div>
                          <div v-else class="insurance-sub-details">
                            <strong>{{ subKey }}:</strong>
                            <span v-if="isDate(subValue)">
                              {{ formatDateBilling(subValue) }}
                            </span>
                            <span v-else>{{ subValue }}</span>
                          </div>
                        </template>
                      </li>
                    </ul>
                  </span>
                  <span v-if="key === 'foundCoverages' && Array.isArray(value)">
                    <ul class="insurance-sub-order">
                      <li
                        v-for="(item, index) in value"
                        :key="index"
                        class="insurance-sub-list"
                      >
                        <div
                          class="main-sub-block"
                          v-for="(subValue, subKey) in item"
                          :key="subKey"
                        >
                          <template
                            v-if="
                              subKey !== 'rawResponse' &&
                              subKey !== 'additionalIdentifications' &&
                              subKey !== 'patient' &&
                              subKey !== 'rejectionCodes'
                            "
                          >
                            <div class="insurance-sub-block">
                              <p class="insurance-label">{{ subKey }}:</p>
                              <span v-if="isObject(subValue)">
                                <ul class="Patient-details">
                                  <li
                                    v-for="(nestedValue, nestedKey) in subValue"
                                    :key="nestedKey"
                                  >
                                    <p class="insurance-label">
                                      {{ nestedKey }}:
                                    </p>
                                    <span v-if="isDate(nestedValue)">
                                      {{ formatDateBilling(nestedValue) }}
                                    </span>
                                    <span v-else>{{ nestedValue }}</span>
                                  </li>
                                </ul>
                              </span>
                              <span v-else>
                                <span v-if="isDate(subValue)">
                                  {{ formatDateBilling(subValue) }}
                                </span>
                                <span v-else>{{ subValue }}</span>
                              </span>
                            </div>
                          </template>
                        </div>
                      </li>
                      <li v-for="addi in value" :key="addi">
                        <div
                          class="main-sub-block"
                          v-for="add in addi.additionalIdentifications"
                          :key="add"
                        >
                          <div class="insurance-sub-block m-10">
                            <p class="insurance-label">
                              Additional Identifications:
                            </p>
                            <div class="sub-details-block">
                              <ul class="Patient-details">
                                <li>
                                  <div class="sub-details">
                                    <p class="insurance-label">
                                      identificationQualifier
                                    </p>
                                    <span>
                                      {{ add.identificationQualifier }}
                                    </span>
                                  </div>
                                </li>
                                <li>
                                  <div class="sub-details">
                                    <p class="insurance-label">identifier</p>
                                    <span>
                                      {{ add.identifier }}
                                    </span>
                                  </div>
                                </li>
                                <li>
                                  <div class="sub-details">
                                    <p class="insurance-label">
                                      identifierDescription
                                    </p>
                                    <span>
                                      {{ add.identifierDescription }}
                                    </span>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li v-for="address in value" :key="address">
                        <div class="main-sub-block">
                          <div class="insurance-sub-block m-10">
                            <p class="insurance-label">Patient Info:</p>
                            <div class="sub-details-block">
                              <ul
                                class="Patient-details"
                                v-if="address && address.patient"
                              >
                                <li
                                  v-for="(value, key) in filteredPatient(
                                    address.patient
                                  )"
                                  :key="value"
                                >
                                  <div class="sub-details">
                                    <p class="insurance-label">
                                      {{ key }}
                                    </p>
                                    <span>
                                      <!-- Check if the value is a date, if so, apply the formatDate function -->

                                      <template
                                        v-if="
                                          key === 'dateOfBirth' && isDate(value)
                                        "
                                      >
                                        {{ formatDateBilling(value) }}
                                      </template>
                                      <!-- If it's not a date, just display the value as it is -->
                                      <template v-else>
                                        {{ value }}
                                      </template>
                                    </span>
                                  </div>
                                </li>

                                <li
                                  v-for="addr in address.patient.addresses"
                                  :key="addr.addressLine1"
                                >
                                  <div class="sub-details">
                                    <p class="insurance-label">
                                      Address Line 1
                                    </p>
                                    <span>
                                      {{ addr.addressLine1 }}
                                    </span>
                                  </div>
                                </li>
                                <li
                                  v-for="addr in address.patient.addresses"
                                  :key="addr.addressLine1"
                                >
                                  <div class="sub-details">
                                    <p class="insurance-label">
                                      Address Line 2:
                                    </p>
                                    <div style="padding: 10px">
                                      <p>{{ addr.addressLine2 }}</p>
                                      <p>City: {{ addr.city }}</p>
                                      <p>State: {{ addr.state }}</p>
                                      <p>Zip: {{ addr.zip }}</p>
                                      <p v-if="addr.zipExtension">
                                        Zip Extension:
                                        {{ addr.zipExtension }}
                                      </p>
                                      <span v-if="addr.county"
                                        >County: {{ addr.county }}</span
                                      >
                                      <span v-if="addr.countyCode"
                                        >County Code:
                                        {{ addr.countyCode }}</span
                                      >
                                    </div>
                                  </div>
                                </li>
                                <li
                                  v-for="addr in address.patient.addresses"
                                  :key="addr.addressLine1"
                                >
                                  <div class="sub-details">
                                    <p class="insurance-label">Reported On</p>
                                  </div>
                                  <span v-if="addr.reportedOn">
                                    {{ addr.reportedOn }}</span
                                  >
                                </li>
                                <li
                                  v-for="addr in address.patient.addresses"
                                  :key="addr.addressLine1"
                                >
                                  <div class="sub-details">
                                    <p class="insurance-label">
                                      Current Address:
                                    </p>
                                  </div>

                                  <span> {{ addr.currentAddress }}</span>
                                </li>
                                <li
                                  v-for="addr in address.patient.addresses"
                                  :key="addr.addressLine1"
                                >
                                  <div class="sub-details">
                                    <p class="insurance-label">
                                      CASS Corrected
                                    </p>
                                  </div>
                                  <span>
                                    {{ addr.cassCorrected }}
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li v-for="addi in value" :key="addi">
                        <div
                          class="main-sub-block"
                          v-if="
                            addi &&
                            addi.rejectionCodes &&
                            addi.rejectionCodes.length
                          "
                        >
                          <div class="insurance-sub-block m-10">
                            <p class="insurance-label">Rejection Codes:</p>
                            <div class="sub-details-block">
                              <ul
                                class="Patient-details"
                                v-for="add in addi.rejectionCodes"
                                :key="add"
                              >
                                <li>
                                  <div class="sub-details">
                                    <p class="insurance-label">Code</p>
                                    <span>
                                      {{ add.code }}
                                    </span>
                                  </div>
                                </li>
                                <li>
                                  <div class="sub-details">
                                    <p class="insurance-label">Location</p>
                                    <span>
                                      {{ add.location }}
                                    </span>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </span>
                  <span v-else>
                    <span v-if="isDate(value)">
                      {{ formatDateBilling(value) }}
                    </span>
                    <span v-else>{{ value }}</span>
                  </span>
                </div>
              </li>
            </template>
          </ul>
        </div>
      </div>
      <div v-else>
        {{
          this.errorMessage
            ? this.errorMessage.critical_error
            : this.errorMessage
        }}
      </div>
      <div class="dialog-footer mr-15">
        <el-button class="blue-save-button" @click="closePopup"
          >Procceed</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      insurancePopup: true,
    };
  },
  props: ["insuranceEligibilityDetails", "errorMessage"],
  methods: {
    closePopup() {
      this.$emit("cancelCase", false);
    },
    handleInsuranceClose() {
      this.$emit("closeDialog", false);
    },
    hasData(obj) {
      return obj && Object.keys(obj).length > 0;
    },
    formatDateBilling(value) {
      return moment(value).format("YYYY-MM-DD");
    },
    isDate(value) {
      return moment(value, moment.ISO_8601, true).isValid();
    },
    isObject(value) {
      return (
        value !== null && typeof value === "object" && !Array.isArray(value)
      );
    },
    filteredPatient(patient) {
      const filtered = {};
      for (const key in patient) {
        if (key !== "addresses") {
          filtered[key] = patient[key];
        }
      }
      return filtered;
    },
  },
};
</script>
<style lang="scss">
#insurance-details {
  border: 1.5px solid #e7e7f7;
  border-radius: 10px;
  margin: 15px;
  padding: 5px;
  .insurance-details-block {
    height: 500px;
    overflow: auto;
    padding: 5px 15px;
    ul {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      column-gap: 20px;
      .insurance-details-list {
        border: 1.5px solid #e7e7f7;
        margin: 5px 0;
        overflow: hidden;
        border-radius: 10px;

        .insurance-block {
          display: grid;
          // grid-template-columns: 1.5fr 3fr;
          align-items: baseline;
          column-gap: 20px;
          font-weight: 500;
          color: #000000;
          span:nth-child(2) {
            padding: 5px 15px;
          }
        }
        .insurance-label {
          color: #005475;
          font-weight: 600;
          font-size: 15px;
          text-transform: capitalize;
          background: #f3f3f3;
          padding: 5px 15px;
        }
        .insurance-sub-order {
          .insurance-sub-list {
            .insurance-sub-block {
              display: grid;
              grid-template-columns: 1.5fr 3fr;
            }
          }
        }

        .main-sub-block {
          .insurance-sub-block {
            border: 1.5px solid #e7e7f7;
            margin: 5px 0;
            overflow: hidden;
            border-radius: 10px;
            &.m-10 {
              margin: 10px;
            }
          }
          &:nth-child(8),
          &:nth-child(9),
          &:nth-child(10),
          &:nth-child(12),
          &:nth-child(13) {
            .Patient-details {
              display: grid;
              grid-template-columns: 1fr 1fr 1fr;
              column-gap: 20px;
              row-gap: 5px;
              color: #000000;
              margin: 0 10px;
              li {
                border: 1.5px solid #e7e7f7;
                margin: 5px 0;
                overflow: hidden;
                border-radius: 10px;
                span:nth-child(2) {
                  padding: 5px 15px;
                  display: inline-flex;
                }
              }
              .insurance-label {
                color: #273480;
                font-weight: 500;
              }
            }
            .insurance-sub-block {
              display: block;
            }
          }
          &:nth-child(16) {
            .insurance-sub-block {
              display: block;
            }
            .Patient-details {
              margin: 0 10px;
              grid-template-columns: 1fr;
              li {
                border: 1.5px solid #e7e7f7;
                margin: 5px 0;
                overflow: hidden;
                border-radius: 10px;
                span:nth-child(2) {
                  padding: 5px 15px;
                  display: inline-flex;
                }
              }
            }
          }
        }
        &:nth-child(7) {
          grid-column: 1 / span 3;
          .insurance-block {
            display: block;
            .insurance-sub-order {
              grid-template-columns: 1fr;
            }
            .insurance-sub-list {
              display: grid;
              grid-template-columns: 1fr;
              column-gap: 20px;
              margin: 10px;
            }
          }
        }
      }
    }
  }
  .sub-details-block {
    .Patient-details {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      column-gap: 20px;
      row-gap: 5px;
      color: #000000;
      margin: 10px;
      li {
        border: 1.5px solid #e7e7f7;
        margin: 5px 0;
        overflow: hidden;
        border-radius: 10px;
        span:nth-child(2) {
          padding: 5px 15px;
          display: inline-flex;
        }
      }
      .insurance-label {
        color: #273480;
        font-weight: 500;
      }
    }
  }
}
</style>